<template>
  <div class="admin-support-container">
    <div class="header">
      Ayuda
    </div>
    <div class="section-menu">
      <div class="section-button" @click="currentSection = 1">
        Información General
      </div>
      <div class="section-button" @click="currentSection = 2">
        Inversionistas
      </div>
      <div class="section-button" @click="currentSection = 3">
        Restaurantes
      </div>
      <div class="section-button" @click="currentSection = 4">
        Retornos de Inversión
      </div>
      <div class="section-button" @click="currentSection = 5">
        Mi Cuenta
      </div>
    </div>
    <Question
      v-for="question in currentQuestions"
      :question="question"
      :key="question.id" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Question from '@/components/admin/Question.vue';

const { mapState, mapActions } = createNamespacedHelpers('support');
export default {
  data() {
    return {
      currentSection: 1,
    };
  },
  methods: {
    getLastElement(questionsArray) {
      for (let i = 0; i < questionsArray.length; i += 1) {
        const element = questionsArray[i];
        if (!element.nextId) {
          return element;
        }
      }
      return null;
    },
    getPreviousElement(questionsArray, id) {
      for (let i = 0; i < questionsArray.length; i += 1) {
        const element = questionsArray[i];
        if (element.nextId === id) {
          return element;
        }
      }
      return null;
    },
    createList(questionsArray) {
      const helpArray = [];
      let currentElement = this.getLastElement(questionsArray);
      while (currentElement !== null) {
        helpArray.unshift(currentElement);
        currentElement = this.getPreviousElement(questionsArray, currentElement.id);
      }
      return helpArray;
    },
    ...mapActions([
      'getQuestions',
    ]),
  },
  watch: {
    currentSectionQuestions() {
      this.createList();
    },
  },
  computed: {
    currentQuestions() {
      const sectionQuestions = this.questions.filter(question => question.section === this.currentSection);
      if (!sectionQuestions) {
        return [];
      }
      return this.createList(sectionQuestions);
    },
    ...mapState([
      'questions',
    ]),
  },
  components: {
    Question,
  },
  async mounted() {
    await this.getQuestions();
  },
};
</script>

<style lang="scss" scoped>
.admin-support-container {
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
.header {
  font-size: 28px;
  font-weight: bold;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.section-menu {
  width: 100%;
  margin: 30px 0 10px 0;
  display: flex;
  justify-content: space-between;
}
.section-button {
  padding: 8px 14px;
  border: 1px solid rgb(223, 223, 223);
  border-radius: 4px;
  cursor: pointer;
  background-color: white;
}
@media only screen and (max-width: 800px) {
  .section-menu {
    flex-wrap: wrap;
  }
  .section-button {
    margin: 5px 0;
  }
}
</style>
